<script setup lang="ts">
import DxButton from 'devextreme-vue/button';
import { useCalcBuildingStore } from "../store/useCalcBuildingStore";
import { ref, computed, onMounted } from "vue";
import DxGallery from 'devextreme-vue/gallery';
import ComplectTextBlock from './ComplectTextBlock.vue'
const props = defineProps<{ item: any }>()
const $buildingStore = useCalcBuildingStore();
const imagePath = 'https://evrazsteelbox.ru/local/templates/evrazsteelbox/images/lk-site/articleimages/'

const itemCount = ref(1)

const isLoading = ref(true)
const isComplect = ref(false)
const treeCount = ref(0)
const loadedArticleTree = ref([] as any)
const textCount = computed(() => {
  return itemCount.value.toString()
})

 onMounted(async()=>{
  const articleTreeArr = props.item.articletree;
  isComplect.value = props.item.type =="complect"?true:false
  if (!isComplect.value){
    isLoading.value = false;
  }

  if (isComplect.value && articleTreeArr && articleTreeArr.length){

    const articleTree = articleTreeArr[0];
    loadedArticleTree.value = [];
    if (articleTree?.items && articleTree.items.length){
      treeCount.value = articleTree.items.length;
      await articleTree.items.forEach(async (x: { articleId: any; count: any; })=>{

        const responseFromServer  = await $buildingStore.fetchArticleByIdfromServer(x.articleId)
        if(responseFromServer?.data && responseFromServer?.data.length){
          const articleFromServer = responseFromServer?.data[0]
          loadedArticleTree.value .push({
            count:x.count,
            article: articleFromServer
          })
        }

      })
   
  }
  }
})  
const showIndicator = computed(()=>{
  if( props.item.imageTemplate?.extraImageUrls &&  props.item.imageTemplate.extraImageUrls.length){
    return true
  }
  else{
    return false
  }
})
const imgDataSource = computed(() => {
  const dataSourceArray = [];


  const imgTemplate = props.item.imageTemplate;
  const mainImg = {
    imageAlt: 'MainImg',
    imageSrc: `${imagePath}${imgTemplate.name}/${imgTemplate.mainImageUrl}`
  }
  dataSourceArray.push(mainImg)
  if (imgTemplate.extraImageUrls && imgTemplate.extraImageUrls.length){
      imgTemplate.extraImageUrls.forEach((element: any) => {
        const imgEl = {
          imageAlt: element,
          imageSrc: `${imagePath}${imgTemplate.name}/${element}`

        }
        dataSourceArray.push(imgEl)
      }
      );
    }
  return dataSourceArray
})


const addItemInBasket = () => {
  for (let i = 0; i < itemCount.value; i++) {
    $buildingStore.addItemInBasket(props.item);
  }
}
const removeUnit = () => {
  if (itemCount.value > 1) {
    itemCount.value -= 1
  }
}
const addUnit = () => {

  itemCount.value += 1

}
</script>

<template>


  <div v-if="item" class="complect-main-div">
    <div class="complect-wrapper-relation">
    <div class="relation-header">
      <div v-if="isComplect" class="relation-complect-header-title"><span>{{ item.headerTitleMiniCard }}</span></div>
      <div v-else class="relation-article-header-title"><span>{{ item.headerTitleMiniCard }}</span></div>
      <div style="height:110px">
        <DxGallery :dataSource='imgDataSource' :show-indicator='showIndicator' :loop="true" :slideshowDelay="5000"></DxGallery>
      </div>
      

    </div>

    <div class="relation-content-wrapper">

    
      <div v-if="item.prices.percent > 0" class="price-block-complect-card">

        <div>
          <div class="relation-discount-price" style="color: #d32f2f">
            <span>{{ item.formatedPrices.priceWithDiscount }}</span>
          </div>
          <div class="relation-without-discount-price" style="text-align: left; color: black;">
            <span>{{ item.formatedPrices.price }}</span>
            
          </div>
        </div>
        <div class="relation-percent-discount">
          -{{ item.prices.percent }}%
          <!-- <span></span> -->
        </div>
      </div>
      <div v-else class="relation-discount-price">
        <span style="text-align: left;">{{ item.formatedPrices.priceWithDiscount }}</span>
        <div style="text-align: left; font-size: 0.75rem;" v-if="item.type == 'door' || item.type == 'gates'">бeз фахверка</div>
      </div>
      
    </div>
    <div class="">
      <div class="relation-secondary-title-block">
        <div v-if="isComplect && loadedArticleTree.length == treeCount" class="relation-secondary-title-block">
            <ComplectTextBlock :items="loadedArticleTree"/>
        </div>
        <div v-else class="relation-footer-title">
          <span>{{item.secondaryTitleMiniCard}}</span>
        </div>
      </div>
    </div>
  </div>
  
    <div v-if="$buildingStore.ifr" class="relation-buttons-group">
      <div v-if="item.type != 'walls' && item.type != 'roof' && item.type != 'complect' && item.type != 'frame'"
        class="relation-buttons-set">
        <DxButton class="relation-counter-button" text="-" :focusStateEnabled="false" styling-mode="text"
          @click="removeUnit" />
        <DxButton class="button-like-numberbox relation-counter-button" :text="textCount" :focusStateEnabled="false"
          styling-mode="text" :hover-state-enabled="false" :activeStateEnabled="false" />
        <DxButton class="relation-counter-button" text="+" :focusStateEnabled="false" styling-mode="text"
          @click="addUnit" />
      </div>
      <DxButton
        :disabled="$buildingStore.getDisabled(item.type).value || !$buildingStore.getDisabled('frame').value || $buildingStore.checkFrame()"
        style="width:100%" class="relation-button-apply relation-counter-button" text="+ ДОБАВИТЬ"
        @click="addItemInBasket" />
    </div>


  </div>

</template>

<style scoped>
.complect-wrapper-relation{
  display: flex;
  flex-direction: column;
  gap:12px;
}
.relation-buttons-group{
  display: flex;
  flex-direction: row;
}

.relation-buttons-set{
  display: flex;
  flex-direction: row;
}
.relation-buttons-set .relation-counter-button.dx-button{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.relation-complect-header-title{
  height: 20px;
  text-align: start ;
}
.relation-article-header-title{
  height: 60px;
  text-align: start ;
}
.relation-secondary-title-block{
  height: 100%;
}
.relation-content-wrapper {

  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.relation-article-title {
  text-align: center;
}

.article-complet-footer-div {
  display: flex;
  align-items: center;
}

.price-block-complect-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
 
}

.button-like-numberbox {
  cursor: default !important
}

.relation-counter-button {
  min-width: 2px !important;
  height: fit-content !important;
 
font-weight: 500 !important;;
font-size: 12px !important;;
line-height: 100% !important;;
letter-spacing: 1% !important;;
text-align: center !important;;
vertical-align: middle !important;;
text-transform: uppercase !important;;

}

.relation-button-apply {
  background-color: #ED7818;
  color: white;


}

.relation-header {
  gap: 2px;

  font-weight: 500;
  font-size: 18px;
  line-height: 110.00000000000001%;
  letter-spacing: 0%;

}

.complect-main-div {
  justify-content: space-between;

  padding-top: 20px;
  padding-right: 25px;
  padding-bottom: 20px;
  padding-left: 25px;
  border: 1px solid #E0E0E0;
  border-width: 1px;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  gap: 12px;


}

.complect-img {
  object-fit: contain;
  height: 98px
}

.relation-recomendation {
  text-align: start;
  color: red;
  font-weight: bold;
  width: fit-content;
  font-size: 12px;
}

.relation-article {
  font-size: 10px;
  color: grey;
  width: 100%;
}

.relation-percent-discount {
  background-color: #d32f2f;
  height: 100%;
  color: white;
  font-size: 1rem;
  padding: 0.375rem;
  padding-top: 0.55rem;
  border-radius: 0.375rem;
}

.relation-discount-price {
  color: #E02F2F;

font-weight: 500;
font-size: 24px;
line-height: 120%;
letter-spacing: 0.16px;
vertical-align: middle;



}

.relation-without-discount-price {
  font-weight: bold;
  font-size: 12px;
  text-decoration: line-through;
  color: grey
}

.relation-footer-title {
  color: #2C2C2C;
text-align: start;
font-weight: 400;
font-size: 10px;
line-height: 120%;
letter-spacing: 0%;

}
</style>
